import { UI, VStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import React from 'react';

export interface ErrorListingProps {
  handleReload: () => void;
}

export const ErrorListing: React.FC<ErrorListingProps> = ({ handleReload }) => {
  return (
    <VStack alignItems="center" paddingY={Spacing['stack.xxxl']}>
      <VStack alignItems="center" space={Spacing['stack.nano']} maxW="330px">
        <UI.Icon name="Warning" color={Color['feedback.attention.default']} size="md" />
        <UI.Text fontSize={Typography['fontsize.lg']} variant="semibold">
          Ops, Algo deu errado!
        </UI.Text>
        <UI.Text fontSize={Typography['fontsize.md']} textAlign="center">
          No momento não conseguimos te mostrar os resultados. Tente novamente em alguns instantes
        </UI.Text>
        <UI.Button
          justifyContent={'flex-start'}
          size={'md'}
          variant="textLink"
          rightIcon={
            <UI.Icon name="Refresh" size="xxs" color={Color['brand.tertiary.principal']} />
          }
          onPress={handleReload}>
          Recarregar
        </UI.Button>
      </VStack>
    </VStack>
  );
};
